
import React from 'react';
import { Button } from '../../../components/base/Button';

export const CTASection: React.FC = () => {
  return (
    <section className="py-16 bg-emerald-600 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 to-emerald-700"></div>
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Get Your Free Loft Insulation Consultation
          </h2>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-8">
            <div className="flex items-center">
              <i className="ri-discount-percent-line text-2xl mr-2"></i>
              <span className="font-semibold">£200 senior discount</span>
            </div>
            <div className="flex items-center">
              <i className="ri-shield-star-line text-2xl mr-2"></i>
              <span className="font-semibold">10% OFF for key workers</span>
            </div>
          </div>
          <Button 
            size="lg" 
            className="bg-white text-emerald-600 hover:bg-gray-100 font-semibold"
            href="/estimate"
          >
            Book Your Free Assessment
          </Button>
          <p className="mt-4 text-emerald-100">
            or<br />
            Call Us Now: <a href="tel:+442476123456" className="font-semibold hover:text-white transition-colors">(024) 7612 3456</a>
          </p>
        </div>
      </div>
    </section>
  );
};
